export const AdminAuequitexMixins = {
  methods: {
    adminType(types = []) {
      const user = this.$store.state.auth.user;
      const userRole = user.user_role;

      return types.includes(userRole)
    }
  },
}